/* eslint-disable i18next/no-literal-string */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom-v5-compat";
import { CreateSessionResponseEnum } from "@b2bportal/auth-api";
import { createSession } from "@b2bportal/core-auth";
import { Select, SelectItem } from "@b2bportal/core-ui";
import { ActionButton } from "@hopper-b2b/ui-core";
import { useAuth } from "@hsbc/auth";
import { isProductionEnv, isThirdPartyDomain } from "@hsbc/utilities";
import { HOME_PATH } from "@hsbc/utilities";
import clsx from "clsx";
import { v4 as uuidv4 } from "uuid";
import "./styles.scss";

// TODO: Pass in config in a better way
const version = import.meta.env.VITE_REACT_APP_VERSION ?? `local-${uuidv4()}`;

type TestUser = {
  userName: string;
  type: "AuthCode" | "TenantId";
  authValue: string;
};

export const MockLoginPage = () => {
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isThirdPartyDomain()) {
      navigate(HOME_PATH, { replace: true });
    }
  }, [navigate]);

  const stagingUsers: TestUser[] = [
    // Login with Auth Code, same to real user
    {
      userName: "Tester 1",
      type: "AuthCode",
      authValue: "e6a00140-e7aa-4ae2-be78-7ee7e1ae96ec",
    },
    {
      userName: "Tester 2",
      type: "AuthCode",
      authValue: "49af8837-7466-4b84-981c-ab33041f56eb",
    },
    {
      userName: "Tester 3",
      type: "AuthCode",
      authValue: "ab290cda-e7e6-48c8-bc3a-8faf15529ea1",
    },
    {
      userName: "Tester 4",
      type: "AuthCode",
      authValue: "2fa6ee96-d82a-4a19-b7a9-770442ea1a6a",
    },
    {
      userName: "Tester 5",
      type: "AuthCode",
      authValue: "29d51994-14df-4ea8-99a5-dc88b84cd281",
    },

    // Login with TenantId via GoogleIdentityBased, protected by google IAP
    {
      userName: "Mock-User-Coco",
      type: "TenantId",
      authValue: "906361700015437727331690999360",
    },
    {
      userName: "Mock-User-Mac",
      type: "TenantId",
      authValue: "600699413661111174077172089291",
    },
    {
      userName: "Mock-User-Meeko",
      type: "TenantId",
      authValue: "863604771601161321398636766010",
    },
    {
      userName: "Mock-User-Nugget",
      type: "TenantId",
      authValue: "876740510087110327737524770166",
    },
    {
      userName: "Mock-User-Piano",
      type: "TenantId",
      authValue: "924413015761781719111151147199",
    },
  ];

  const prodUsers = [
    // Todo, add Nikhil's account
    {
      userName: "Mock-User-Coco",
      type: "TenantId",
      authValue: "906361700015437727331690999360",
    },
    {
      userName: "Mock-User-Mac",
      type: "TenantId",
      authValue: "600699413661111174077172089291",
    },
  ];

  const testUsers = isProductionEnv() ? prodUsers : stagingUsers;

  const [selectedUser, setSelectedUser] = useState(testUsers[0]);

  const onLoginClick = async () => {
    try {
      let res;
      if (selectedUser.type === "AuthCode") {
        res = await createSession({
          CreateSessionRequest: "SignIn",
          authMethod: {
            AuthMethod: "PartnerToken",
            token: selectedUser.authValue,
          },
        });
      } else {
        res = await createSession({
          CreateSessionRequest: "SignIn",
          authMethod: {
            AuthMethod: "GoogleIdentityBased",
            idToken: selectedUser.authValue,
          },
        });
      }
      if (
        res.CreateSessionResponse ===
        CreateSessionResponseEnum.CreateSessionSuccess
      ) {
        login();
        navigate(HOME_PATH);
      } else {
        console.log("create session rejected:", res.CreateSessionResponse);
      }
    } catch (error) {
      console.error("error creating session info:", error);
    }
  };

  return (
    <div className={clsx("hsbc-mock-login-page")}>
      <h3>Please select a user to login:</h3>
      <Select
        placeholder={"Select a user"}
        defaultValue={selectedUser.authValue}
        onValueChange={(v) =>
          setSelectedUser(testUsers.find((u) => u.authValue === v)!)
        }
      >
        {testUsers.map((user) => {
          return (
            <SelectItem key={user.userName} value={user.authValue}>
              {user.userName}
            </SelectItem>
          );
        })}
      </Select>

      <ActionButton
        size="medium"
        message={"Login"}
        className="login-button"
        onClick={onLoginClick}
      />

      <span className={"version"}>{version}</span>
    </div>
  );
};
